import axios from 'axios';
import { urls } from './urls';

// Base API configuration
const api = axios.create({
  baseURL: urls.baseURL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    // Try both token storage keys for compatibility
    const token = localStorage.getItem('TOKEN') || localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle common errors
api.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('TOKEN');
      localStorage.removeItem('authToken');
      localStorage.removeItem('userData');
      localStorage.removeItem('Role');
      localStorage.removeItem('CurrentScreen');
      window.location.href = '/auth/login';
    }
    return Promise.reject(error.response?.data || error);
  }
);

// HTTP GET without token
export const getHttp = async (url: string, navigation?: any) => {
  try {
    const response = await api.get(url);
    return response.data;
  } catch (error: any) {
    console.error('GET Error:', error);
    if (navigation) {
      // Handle navigation for errors if needed
    }
    throw error;
  }
};

// HTTP GET with token
export const getHttpwithtoken = async (url: string, navigation?: any) => {
  try {
    const response = await api.get(url);
    return response.data;
  } catch (error: any) {
    console.error('GET with token Error:', error);
    if (navigation) {
      // Handle navigation for errors if needed
    }
    throw error;
  }
};

// HTTP POST with token
export const postHttpwithtoken = async (url: string, data: any, navigation?: any) => {
  try {
    const response = await api.post(url, data);
    return response.data;
  } catch (error: any) {
    console.error('POST with token Error:', error);
    if (navigation) {
      // Handle navigation for errors if needed
    }
    throw error;
  }
};

// HTTP PUT with token
export const putHttpwithtoken = async (url: string, data: any, navigation?: any) => {
  try {
    const response = await api.put(url, data);
    return response.data;
  } catch (error: any) {
    console.error('PUT with token Error:', error);
    if (navigation) {
      // Handle navigation for errors if needed
    }
    throw error;
  }
};

// HTTP DELETE with token
export const deleteHttpwithtoken = async (url: string, navigation?: any) => {
  try {
    const response = await api.delete(url);
    return response.data;
  } catch (error: any) {
    console.error('DELETE with token Error:', error);
    if (navigation) {
      // Handle navigation for errors if needed
    }
    throw error;
  }
};
